import { z } from "zod";

const toText = (value) => {
  if (value == null) return "";
  if (typeof value === "number") return String(value);
  return value;
};

const requiredText = (label) =>
  z.preprocess(
    toText,
    z
      .string({ required_error: `${label} is required` })
      .trim()
      .min(1, `${label} is required`)
  );

export const RentersStep3Schema = z.object({
  priorCarrier: requiredText("Prior carrier"),
  priorLiabilityLimit: requiredText("Prior liability limit"),
  reportedClaims: requiredText("Reported claims"),
});
